import React from "react";
import {Skeleton} from "primereact/skeleton";

function HomePulse({focusCount, attentionCount, actionCount, loading, translate}) {
    const unavailable = translate("home.pulse.unavailable");
    const stats = [
        {key: "focus", value: focusCount === null ? unavailable : `${formatNumber(focusCount)}/${formatNumber(3)}`, label: translate("home.pulse.focus-selected")},
        {key: "attention", value: attentionCount === null ? unavailable : formatNumber(attentionCount), label: translate("home.pulse.attention-required"), valueClass: attentionCount > 0 ? "text-primary" : ""},
        {key: "action", value: actionCount === null ? unavailable : formatNumber(actionCount), label: translate("home.pulse.action-required")},
    ];

    const hasCompleteSummary = focusCount !== null && attentionCount !== null && actionCount !== null;
    const summary = hasCompleteSummary
        ? translate("home.pulse.summary").replace("{{focus}}", formatNumber(focusCount)).replace("{{attention}}", formatNumber(attentionCount)).replace("{{actions}}", formatNumber(actionCount))
        : translate("home.pulse.incomplete");

    return (
        <section data-home-section="pulse" className="brand-secondary-muted text-900 border-2 border-round-xl shadow-2 overflow-hidden px-3 py-3 md:px-4 flex flex-column md:flex-row md:align-items-center justify-content-between gap-4" aria-labelledby="home-pulse-title">
            <div className="flex align-items-center gap-3 min-w-0">
                <span data-testid="home-pulse-icon" className="w-3rem h-3rem flex align-items-center justify-content-center border-round-xl brand-secondary-surface flex-shrink-0"><i className="pi pi-chart-line text-lg" aria-hidden="true"/></span>
                <div className="min-w-0"><small className="block text-xs text-500 mb-1">{translate("home.pulse.label")}</small><strong id="home-pulse-title" className="block text-sm md:text-base text-900 line-height-3">{loading ? translate("home.pulse.description") : summary}</strong></div>
            </div>
            <div className="grid grid-nogutter w-full md:w-auto md:flex-nowrap" aria-label={translate("home.pulse.stats-label")}>
                {stats.map((stat, index) => <div key={stat.key} className={`col-12 sm:col-4 md:w-8rem px-2 py-2 sm:py-0 ${index ? "sm:border-right-1 border-200" : ""}`}><span className={`block text-lg text-900 font-bold ${stat.valueClass}`}>{loading ? <Skeleton width="3rem" height="1.25rem"/> : stat.value}</span><small className="block text-xs text-500 mt-1">{stat.label}</small></div>)}
            </div>
        </section>
    );
}

function formatNumber(value) {
    return new Intl.NumberFormat(undefined, {maximumFractionDigits: 0}).format(value);
}

export default HomePulse;
